import React from 'react';
import { FiGithub, FiLinkedin, FiMail, FiHeart } from 'react-icons/fi';
import { Link } from 'react-scroll';

const links = [
  { label: 'About', to: 'about' },
  { label: 'Skills', to: 'skills' },
  { label: 'Experience', to: 'experience' },
  { label: 'Projects', to: 'projects' },
  { label: 'Education', to: 'education' },
  { label: 'Contact', to: 'contact' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          {/* Brand */}
          <div>
            <span className="font-display font-bold text-xl">
              <span className="gradient-text">Kallesh D R</span>
              <span className="text-slate-400 font-light ml-1">Portfolio</span>
            </span>
            <p className="text-slate-400 text-sm mt-2 max-w-xs">
              Software Development Engineer. Builder of real products. Based in Bengaluru, India.
            </p>
          </div>

          {/* Nav Links */}
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                smooth
                duration={500}
                offset={-70}
                className="text-slate-400 hover:text-white text-sm cursor-pointer transition-colors duration-200"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Social */}
          <div className="flex gap-3">
            {[
              { icon: FiGithub, href: 'https://github.com/kalleshdr', label: 'GitHub' },
              { icon: FiLinkedin, href: 'https://www.linkedin.com/in/kallesh-dr-087008235', label: 'LinkedIn' },
              { icon: FiMail, href: 'mailto:kallesh953@gmail.com', label: 'Email' },
            ].map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="w-10 h-10 rounded-xl bg-slate-800 hover:bg-primary-600 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200"
              >
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} Kallesh D R. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs flex items-center gap-1">
            Built with <FiHeart size={11} className="text-rose-400 fill-rose-400" /> using React & Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
}
